export default `
  @import url('https://fonts.googleapis.com/css?family=Oxygen:300,400,700');
  
  @font-face {
    font-family: Hill;
    src: url(/fonts/Hill_Light.otf);
    font-style: normal;
    font-weight: 300;
  }

  @font-face {
    font-family: Hill;
    src: url(/fonts/Hill_DemiBold.otf);
    font-style: normal;
    font-weight: 600;
  }

  @font-face {
    font-family: Hill;
    src: url(/fonts/Hill_Heavy.otf);
    font-style: normal;
    font-weight: 900;
  }
`



// WEBPACK FOOTER //
// ./src/ui/styles/fonts.js